import React from 'react';
import './report.css';
import jwt_decode from "jwt-decode";
import moment from 'moment';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

import {
    sendEmail,
} from '../../actions';
import {
    Input,
    Button,
    FormGroup,
    Label,
    Modal,
    ModalBody,
    ModalHeader,
    Form,
} from 'reactstrap';
import { connect } from "react-redux";
import { appInsights } from "../../AppInsights";
import { SeverityLevel } from '@microsoft/applicationinsights-common';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileUpload, faEnvelopeOpenText,faCheckCircle} from '@fortawesome/free-solid-svg-icons';
const initialState = {
    email: '',
    phone: '',
    subject: '',
    message: '',
    attachment: '',
    type: '',
    isEmailSentOpen: false,
    fileName: ''
}
class Report extends React.Component {
    constructor(props) {
        super(props)
        this.state = initialState


    }

    handleSubmit(e) {
        const { IssueTitle, Message, attachment, type } = this.state
        e.preventDefault()
        this.setState(prevState => ({
            isReportModalOpen: false,
        }));
        if (IssueTitle === "" || IssueTitle === undefined) {
            let message = "Please give the Issue title"
            appInsights.trackTrace({message: message, properties:{page: "report"}, severityLevel: SeverityLevel.Verbose})
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        else if (Message === "" || Message === undefined) {
            let message = "Please enter some message"
            appInsights.trackTrace({message: message, properties:{page: "report"}, severityLevel: SeverityLevel.Verbose})
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        else {
            let user
            if (localStorage.getItem("auth_token")) {
                user = jwt_decode(localStorage.getItem("auth_token"))
            }
            let page = window.location.pathname
            let origin = window.location.origin
            let body = { heading: origin, page: page, reportedBy: user.unique_name, message: Message, dateTime: moment(new Date()).format('YYYY-MM-DD hh:mm:ss') }
            let htmlTemplate = `
                <!DOCTYPE html>
                  <html>
                    <body>
                       <div>
                        <p>We are notifying due to the issue reported on<strong> </strong><a href=${body.heading} target="_blank" rel="noopener noreferrer" data-auth="NotApplicable" data-linkindex="0">${body.heading}</a></p>
                        <p><span style="text-decoration:underline"><strong>Details</strong></span></p>
                        <strong>Reported By&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; :&nbsp;  ${body.reportedBy}</strong>
                        <p><strong>Reported at&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;:&nbsp; ${body.dateTime}</strong></p>
                        <p><strong>Pagename&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;:&nbsp; ${body.page}</strong></p>
                        <p><strong>Message&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; :&nbsp; ${body.message}</strong></p>
                       </div>     
                     </body>
                </html> `;
            let data = {
                subject: IssueTitle,
                body: body,
                html: htmlTemplate,
                attachment: attachment,
                type: type
            }
            this.props.sendEmail(data)
                .then(response => {
                    if (response.status === 202) {
                        this.setState({
                            isEmailSentOpen: true
                        })
                        appInsights.trackTrace({message: "Report Sent Successfully", properties:{page: "report", name: IssueTitle}, severityLevel: SeverityLevel.Verbose})
                    }
                    else {
                        let message = "There is some issue in reporting.Please Try again"
                        appInsights.trackTrace({message: message, properties:{page: "report", name: IssueTitle}, severityLevel: SeverityLevel.Error})
                        toast.error(message, {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });
                    }
                }).catch((error) => {
                    let message = "There is some issue in reporting.Please Try again"
                    appInsights.trackTrace({message: message, properties:{page: "report", name: IssueTitle, error: error}, severityLevel: SeverityLevel.Error})
                    toast.error(message, {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                })
            this.resetForm()
        }
    }

    resetForm() {
        this.setState({
            subject: '',
            message: '',
            fileName: '',
        })
    }

    validateData = (data) => {
        if (!data.IssueTitle || data.IssueTitle === " ") {
            let message = localStorage.getItem("guest")?"Invalid Name":"Invalid Title"
            appInsights.trackTrace({message: message, properties:{page: "report"}, severityLevel: SeverityLevel.Verbose})
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
        
        if (localStorage.getItem("guest") && data.email && data.email !== " " && data.split("@").length === 2 && data.split(".").length >= 2){
        let message =  "Invalid Email"
        appInsights.trackTrace({message: message, properties:{page: "report"}, severityLevel: SeverityLevel.Verbose})
        toast.error(message, {
            position: toast.POSITION.BOTTOM_RIGHT
        });
        }
    }

    handleChange = (param, e) => {
        this.setState({ [param]: e.target.value })
    }

    handleFileChange = ({ target: { files } }) => {
        this.setState({ attachment: files[0] ,
            fileName: files[0].name,
            type:files[0].type
        });

    }
    toggleEmailSent = () =>{
        this.setState(prevState => ({
            isEmailSentOpen: false,
        }))
    }
    toggleReport = () =>{
        this.props.report()
        this.setState ({
            fileName: "",
        })
    }


    render() {
        return (
            <div >
                <Modal isOpen={this.props.isReportModalOpen} toggle={this.toggleReport} size="lg">
                    <ModalHeader toggle={this.toggleReport} className="edit-popup">Report Issue
                    </ModalHeader>
                    <ModalBody >
                        <Form onSubmit={this.handleSubmit.bind(this)}>
                            <FormGroup className="report-form-header">
                                <div>
                                    <Label className="edit-label-names">Issue Title<span className="required-icon">*</span></Label>
                                    <Input className="edit-input-values" type="text" name="IssueTitle" size="10" onChange={this.handleChange.bind(this, 'IssueTitle')} />
                                    <Label className="edit-label-names">Message<span className="required-icon">*</span> </Label>
                                    <Input className="edit-input-values  report-input-msg" type="textarea" name="Message" onChange={this.handleChange.bind(this, 'Message')} placeholder="Type your message here"  />
                                    <Label className="edit-label-names">Attachments (e.g. Screenshot of error)</Label>
                                    {!this.state.fileName && <FontAwesomeIcon className="report-upload-icon" icon={faFileUpload} size="lg" />}
                                    <Input
                                        className="upload-file report-file"
                                        data-title={this.state.fileName || "Choose a file"}
                                        type="file"
                                        ref={(ref) => this.upload = ref}
                                        onChange={(e) => this.handleFileChange(e)}
                                    />
                                </div>
                                <div className="float-right ml-auto">
                                    <Button className="button-cancel mr-2 report-cancel" outline color="secondary" onClick={this.toggleReport}>Cancel</Button>
                                    <Button className="button-size save-upload-delete-button" type="submit" onClick={this.props.report}>
                                    Report issue
                                    </Button>
                                </div>
                            </FormGroup>
                        </Form>

                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.isEmailSentOpen} toggle={this.toggleEmailSent} className="mail-sending">
                    <ModalBody className="report-success-body">
                        <div className='email-outline' >
                            <FontAwesomeIcon icon={faCheckCircle} className="fa-1x demo-icon icon-check" ></FontAwesomeIcon>
                            <div className='email-sent'>
                                <FontAwesomeIcon icon={faEnvelopeOpenText} className="fa-1x demo-icon msg-icon" />
                                <p>Thank You</p>
                                <p className='report-success-msg'>Your Issue has been reported successfully!</p>
                                <div className='report-sucsess-div'>We will resolve and respond via email as soon as possible</div>
                                <Button style={{ width: "50px" }} className="button-size save-upload-delete-button" onClick={() => this.toggleEmailSent()}>Ok</Button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}
export default connect(null, {sendEmail})(Report);